module.exports = __webpack_public_path__ + "img/152.3cf5b1b0.jpg";